export const TOKEN_KEY = "hypegrow-casino-template-auth-token";
export const USER_KEY = "hypegrow-casino-template-session-user";
